import { PHASE_PRODUCTION_BUILD } from 'next/dist/shared/lib/constants'

import { isServer } from '@tanstack/react-query'
import { getRequestConfig, RequestConfig } from 'next-intl/server'

import { defaultLocale } from '@/lib/i18n/i18n-config'
import { messages } from '@/lib/i18n/messages'

export const locales = ['en', 'ar'] as const

export { defaultLocale }

export type Locales = (typeof locales)[number]

export async function getLocale(): Promise<Locales> {
  try {
    if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
      return defaultLocale
    }

    // Client-side: read from document.cookie
    if (!isServer) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; NEXT_LOCALE=`)

      if (parts.length === 2) {
        const cookieValue = parts.pop()?.split(';').shift()
        if (cookieValue && locales.includes(cookieValue as Locales)) {
          return cookieValue as Locales
        }
      }

      return defaultLocale
    }

    const { cookies } = await import('next/headers')
    const cookiesStore = await cookies()
    const localeCookie = cookiesStore.get('NEXT_LOCALE')

    if (
      localeCookie?.value &&
      locales.includes(localeCookie.value as Locales)
    ) {
      return localeCookie.value as Locales
    }
  } catch {
    console.warn('Failed to read locale from cookies, using default.')
  }
  return defaultLocale
}

export default getRequestConfig(async () => {
  const locale = await getLocale()

  return {
    locale,
    messages: messages[locale] as RequestConfig['messages']
  }
})
